import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import am from "./locales/am/translation.json";
import or from "./locales/or/translation.json";

// Load language from localStorage, default to 'en' if not found
const savedLanguage = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    am: { translation: am },
    or: { translation: or },
  },
  lng: savedLanguage, // Use saved language or default to 'en'
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
